/* eslint-disable jsx-a11y/img-redundant-alt */
import React from 'react'
import ticket from 'assets/ticket-gradient.svg'
import { useStyles } from './styles'
import whiteLogo from 'assets/logo-iso-white.svg'

export const HeaderSuccess = ({ artist }) => {
    const classes = useStyles()

    return (
        <div className={classes.container}>
            <img className={classes.navLogo} src={whiteLogo} alt="Logo" />

            <img className={classes.ticket} src={ticket} alt={'Ticket to the show'} />

            <div className={classes.overlayContents}>
                <img className={classes.artistImg} src={artist.artistImg} alt="Artist image" />
                <p className={classes.ticketTitle}>{artist.name} Priority List</p>
                <p className={classes.ticketQuantity}>Spot Secured</p>
            </div>
        </div>
    )
}

export default React.memo(HeaderSuccess)
